import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, Select, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { getNotificationsGroups, modifyApprovalGroups, saveApprovalGroups } from "../../../api/s10OrganizationApi";
import { ModifyApprovalGroup, NotificationGroup } from "../../../interfaces/auth.interface";
import MyTextField from "../../../components/MyTextField";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';



interface CreateApprovalGroupModalProps {
    approvalGroupToEdit?: ModifyApprovalGroup;
    companyId: string;
    handleCloseModal: ({success, msg}: {success?: boolean, msg?: string}) => void;
}

const CreateApprovalGroupModal = ({handleCloseModal, companyId, approvalGroupToEdit}: CreateApprovalGroupModalProps) => {

    const theme = useTheme();
    const [loading, setLoading] = useState<boolean>(false);
    const [notificationGroups, setNotificationGroups] = useState<NotificationGroup[]>([]);
    const [selectedNotificationGroup, setSelectedNotificationGroup] = useState<string>(
        approvalGroupToEdit?.NotificationGroupId
            ? String(approvalGroupToEdit?.NotificationGroupId)
            : "");
    const [selectedBVNumber, setSelectedBVNumber] = useState<string>(approvalGroupToEdit?.ApproversNumber 
            ? String(approvalGroupToEdit?.ApproversNumber) 
            : "1"
    );
    const [name, setName] = useState<string>(approvalGroupToEdit?.Name || "");

    useEffect(() => {
        if (loading) {
            return;
        }
        setLoading(true)
        getNotificationsGroups(companyId)
            .then(response => {
                setLoading(false)
                console.log(response)
                setNotificationGroups(response.data);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleModifyAppovalGroup = async () => {
        setLoading(true);
        const {data} = await modifyApprovalGroups({
            Id: approvalGroupToEdit?.Id as any,
            Name: name,
            ApproversNumber: Number(selectedBVNumber),
            NotificationGroupId: Number(selectedNotificationGroup),
            CompanyCode: companyId,
        } as any);
        const msg = data?.Type === 0
            ? 'Grupo actualizado con éxito.'
            : data?.Message || 'Error actualizando el grupo';
        setLoading(false);
        handleCloseModal({
            success: data?.Type === 0,
            msg,
        });

    }

    const handleSaveAppovalGroup = async () => {
        setLoading(true);
        const {data} = await saveApprovalGroups({
            Name: name,
            ApproversNumber: Number(selectedBVNumber),
            NotificationGroupId: Number(selectedNotificationGroup),
            CompanyCode: companyId,
        });
        const msg = data?.Type === 0
            ? 'Grupo creado con éxito.'
            : 'Error creando el grupo';
        setLoading(false);
        handleCloseModal({
            success: data?.Type === 0,
            msg,
        });

    }

    const handleSaveAction = async () => {
        if (loading) {
            return;
        }
        if (approvalGroupToEdit?.Id !== undefined) {
            await handleModifyAppovalGroup();
        } else {
            await handleSaveAppovalGroup();
        }
    }

    return (

        <Dialog
            open={true}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Grupo de aprobación
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
                <Grid container spacing="1.5rem">
                    <Grid item xs={12}>
                        <MyTextField 
                            style={{width: "100%"}} 
                            label="Nombre"
                            onChange={({target}) => setName(target.value)}
                            value={name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography 
                            // variant="caption"
                            align='left'
                            style={{
                                color: theme.s10palette.S10Greygrey700,
                                fontSize: "1rem",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "1.25",
                        }}
                        >
                            Número V°B° para aprobación
                        </Typography>
                        <Select
                            labelId="select-option-label"
                            id="select-option"
                            // label={"Grupo de notificación"}
                            onChange={(event: { target: { value: string } }) => {
                                const value = event.target.value;
                                setSelectedBVNumber(String(value));
                            }}
                            value={selectedBVNumber}
                            style={{height: "2.5rem", border: "none", backgroundColor: "white", textAlign: "left"}}
                        >
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((item, i) => (
                                <MenuItem
                                    key={i} 
                                    value={item}
                                >
                                    {item}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography 
                            // variant="caption"
                            align='left'
                            style={{
                                color: theme.s10palette.S10Greygrey700,
                                fontSize: "1rem",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "1.25",
                        }}
                        >
                            Grupo de notificación
                        </Typography>
                        <Select
                            labelId="select-option-label"
                            id="select-option"
                            // label={"Grupo de notificación"}
                            onChange={(event: { target: { value: string } }) => {
                                const value = event.target.value;
                                setSelectedNotificationGroup(String(value));
                            }}
                            disabled={!notificationGroups?.length}
                            value={selectedNotificationGroup}
                            style={{height: "2.5rem", border: "none", backgroundColor: "white", textAlign: "left"}}
                        >
                            {notificationGroups?.map((item, i) => (
                                <MenuItem
                                    key={i} 
                                    value={item.Id}
                                >
                                    {item.Name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem"}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => handleCloseModal({})}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button 
                            variant="contained" 
                            style={{width: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            disabled={!selectedNotificationGroup || !name}
                            onClick={handleSaveAction}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default CreateApprovalGroupModal;